import { Component, OnInit,ChangeDetectorRef } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { LoginService } from "src/app/core/login/login.service";
import { AppraisalService } from "src/app/core/services/appraisal.service";
import { LearnerService } from "src/app/core/services/learner.service";
import { LoaderService } from "src/app/core/services/loader.service";
import { ESeparationService } from "src/app/core/services/e-separation.service";
import { SidebarService } from 'src/app/core/services/sidebar.service';
import { PromotionHistoryComponent } from "../appraisal/promotion-history/promotion-history.component";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";


@Component({
  selector: "app-e-separation",
  templateUrl: "./e-separation.component.html",
  styleUrls: ["./e-separation.component.css"],
})
export class ESeparationComponent implements OnInit {
  sidebarCollapsed: boolean = false;
  user: any;
  lndUserType: any;
  name: any;
  emp: any;
  id: any;
  exitForm: FormGroup;
  teamData: any;
  whatsappNo: number;
  personalEmail: any;
  exitReason: any;
  empData: any;
  isHrManager :any;
  isManager :any;
  calculatedExitDate: any;
  resignationDate: any;
  proposedDate: string = "";
  comingProposedDate: string = "";
  exitFormId: number;
  promotionData: any;
  empSeparation: any;
  canEditDate: boolean = true; 
  renderPromotion: boolean = false;
  showRemarkDiv: boolean;
  remark: string = '';
  showNoRecordsAvailable: boolean = false;
  leaveAdjustment: string = 'NA'; // Added leaveAdjustment property
  selectedUser: any = null; // Added selectedUser property
  approvalTypes: { [key: string]: string } = {}; // Initialize approvalTypes as an empty object
  approvalType: any ="NA";


  constructor(
    private learnerService: LearnerService,
    private loginService: LoginService,
    private appraisalService: AppraisalService,
    public loaderService: LoaderService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private eSeparationService: ESeparationService,
    private cdr: ChangeDetectorRef,
    private sidebarService: SidebarService
  ) {}

  ngOnInit() {
    // Subscribe to sidebar collapsed state
    this.sidebarService.collapsed$.subscribe(collapsed => {
      this.sidebarCollapsed = collapsed;
    });
    
    this.learnerService.getUserType().subscribe(
      (res) => {
        this.user = res["lnd_user_type"];
        this.lndUserType = true;
        localStorage.setItem("user_type", res["lnd_user_type"]);
      },
      (error: any) => {
        console.log(error, error.error, error.message);
        if (error.error == "Signature has expired") {
          this.loginService.logout();
        }
      }
    );

    this.learnerService.getEmployeeDetails().subscribe(
      (res: any) => {
        this.emp = res.data;
        this.name = res.data.name;
        this.id = res.data.emp_id;
        // this.isHrManager = res.employee_permissions.hr_manager;
        // this.isManager = res.employee_permissions.manager;
        console.log(this.emp, "----------emp data");
      },
      (error: any) => {
        console.log(error, error.error, error.message);
        if (error.error == "Signature has expired") {
          this.loginService.logout();
        }
      }
    );

    this.eSeparationService.getTeamSeperation().subscribe(
      (res: any) => {
        console.log(res);
        this.teamData = res.data;
        this.checkExitForms();
      },
      (error: any) => {
        console.log(error, error.error, error.message);
        if (error.error == "Signature has expired") {
          this.loginService.logout();
        }
      }
    );
  }

  checkExitForms() {
    // Check if exit_forms array exists and has no data
    if (!this.teamData || this.teamData.length === 0) {
      this.showNoRecordsAvailable = true;
    }
  }


  

  submitFormAcknowledge(status: string): boolean {
    const data = {
      proposed_date: this.comingProposedDate ? this.comingProposedDate : this.calculatedExitDate,
      leave_adjustment: this.approvalType,
      remark: this.remark,
      exit_form_id: this.exitFormId,
      resignation_date: this.resignationDate,
      status: status,
    };
  
    if (this.showRemarkDiv) {
      if (this.isManager && (!this.approvalType || !this.remark)) {
        alert("Please fill both EL Leave Adjustment and Remark.");
        return false; // Stops modal from closing
      } 
    }

    // alert(JSON.stringify(data));
  
    this.eSeparationService.acknowledgeForm(data).subscribe({
      next: (response: any) => {
        console.log("Response:", response);
        if (response && response.status === true) {
          window.location.reload();
          return true; 
        } else {
          alert(response.message || "An error occurred.");
          return false; 
        }
      },
      error: (error: any) => {
        console.error("Error:", error);
        const data = error?.error?.data || error?.data || "An unexpected error occurred.";
        alert(data);
        return false; 
      },
    });
  
    return true; // Adjust based on your needs
  }




  onDateChange(event: any): void {
   
    console.log('Proposed Date:', event); // Debugging line
    this.proposedDate = event;
    this.comingProposedDate = event;
    if (event !== this.calculatedExitDate) {
     
       this.showRemarkDiv = true;
    } else {
     
      this.showRemarkDiv = false;
    }
   // this.cdr.detectChanges(); // Manually trigger change detection
  }

  onResignationDateChange(event: any): void {
    console.log('Resignation Date:', event); // Debugging line
    this.resignationDate = event;
    // Add any specific logic for resignation date changes if needed
  }

  onProposedDateChange(event: any): void {
    console.log('Proposed Date:', event); // Debugging line
    this.proposedDate = event;
    this.comingProposedDate = event;
    if (event !== this.calculatedExitDate) {
       this.showRemarkDiv = true;
    } else {
      this.showRemarkDiv = false;
    }
  }

  resetFormProperties() {
    this.remark = '';
    this.proposedDate = '';
    this.leaveAdjustment = '';
    this.showRemarkDiv = false;
  }

getEmployeeExitDetails(id, user: any) {
  // Reset form properties
  this.remark = ''; // Reset remark
  this.proposedDate = ''; // Reset proposed date
  this.leaveAdjustment = ''; // Reset selected car
  this.showRemarkDiv = false; // Hide remark div

  // Set the exit form ID and selected user
  this.exitFormId = id;
  this.selectedUser = user;

  // Fetch employee exit details
  this.eSeparationService.employeeExitDetails(id).subscribe(
    (res: any) => {
      console.log(res);
      const {
        exit_reason,
        personal_email,
        whatsapp_no,
        calculated_exit_date,
        resignation_date,
        approval_type_list,
        proposed_date,
        exit_remarks,
        approval_type,
        is_manager,
        is_hr,


        
      } = res.data;
      this.empData = res.data;
      this.exitReason = exit_reason;
      this.personalEmail = personal_email;
      this.whatsappNo = whatsapp_no;
      this.calculatedExitDate = calculated_exit_date;
      this.resignationDate = resignation_date;
         // alert("1111" +this.resignationDate);
      this.approvalTypes = approval_type_list; 
      this.comingProposedDate = proposed_date !== null && proposed_date !== undefined ? proposed_date : calculated_exit_date;
      this.remark = exit_remarks;
      this.approvalType=approval_type;
      this.isHrManager = is_hr;
      this.isManager = is_manager;
    },
    (error: any) => {
      console.log(error, error.error, error.message);
      if (error.error == "Signature has expired") {
        this.loginService.logout();
      }
    }
  );
}

  getSeparationEmpRequestsDetails(id) {
    this.eSeparationService.getSeparationEmpRequestsDetails(id).subscribe(
      (res: any) => {
        this.empSeparation = res.data;
        this.getPromotions(id);
      },
      (error: any) => {
        console.log(error, error.error, error.message);
        if (error.error == "Signature has expired") {
          this.loginService.logout();
        }
      }
    );
  }

  getPromotions(id) {
    this.eSeparationService.getExitPortalPromotion(id).subscribe(
      (res: any) => {
        this.renderPromotion = true;
        this.promotionData = res.data;
      },
      (error: any) => {
        console.log(error, error.error, error.message);
        if (error.error == "Signature has expired") {
          this.loginService.logout();
        }
      }
    );
  }

  openRemarkPopup(user: any) {
    this.selectedUser = user;
  }

  closeRemarkPopup() {
    this.selectedUser = null;
  }
   // Helper function to get keys of an object
   objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }
}